import React, { useState, useEffect, useRef } from "react";
import { Typography } from "antd";
import { Session } from "../../../../Entities/Session";
import { InterviewRound } from "../../../../Dto/GenerateJobDescription.dto";
import { JobDescriptionEntity } from "../../../../Entities/JobDescription";
import JobApplicationinterviewRoundsDetailsSummary from "./JobApplicationinterviewRoundsDetailsSummary";
import JobApplicationinterviewRoundsDetailsQuestions from "./JobApplicationinterviewRoundsDetailsQuestions";
import SimulationReportPanel from "./SimulationReportPanel";
import { Question } from "../../../../Entities/Question";
import { useLoader } from "../../../../Context/LoaderContext";
import interviewService from "../../../../Service/interview.service";

interface JobApplicationinterviewRoundsDetailsProps {
  selectedSession: Session;
  interviewRounds: InterviewRound[];
  jobPost: JobDescriptionEntity;
  handleViolationModal: () => void;
  handleScreenRecordingModal: () => void;
  questionFilter: "all" | "qualified" | "unqualified" | "pending";
  setQuestionFilter?: (filter: "all" | "qualified" | "unqualified" | "pending") => void;
  passPercentage: number;
  isMustQualify: boolean;
  attemptNumber?: number;
  isRestarted?: boolean;
}

const JobApplicationinterviewRoundsDetails: React.FC<
  JobApplicationinterviewRoundsDetailsProps
> = ({
  selectedSession,
  interviewRounds,
  jobPost,
  handleViolationModal,
  handleScreenRecordingModal,
  questionFilter,
  setQuestionFilter,
  passPercentage,
  isMustQualify,
  attemptNumber,
  isRestarted,
}) => {
  const { setLoading, setLoadingMessage } = useLoader();
  const [roundQuestions, setRoundQuestions] = useState<Question[]>([]);
  const detailsContentRef = useRef<HTMLDivElement>(null);

  const selectedRound = interviewRounds.find(
    (round) => round._id === selectedSession.interviewRoundId
  );

  // Get round config from jobPost.interviewRounds for passPercentage and isMustQualify
  // These values are stored in the job description, not in the session
  const roundConfig = jobPost?.interviewRounds?.find(
    (r) => r.interviewRoundId === selectedSession.interviewRoundId
  );

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      setLoadingMessage("Loading round questions...");
      try {
        const questions = await interviewService.getQuestionsBySessionId(
          selectedSession._id
        );
        setRoundQuestions(questions || []);
      } catch (error: any) {
        console.error(
          "JobApplicationinterviewRoundsDetails -> init: Error loading round questions",
          error
        );
        setRoundQuestions([]);
      } finally {
        setLoading(false);
        setLoadingMessage(null);
      }
    };

    if (selectedSession) {
      init();
    }
  }, [selectedSession, setLoading, setLoadingMessage]);

  useEffect(() => {
    if (detailsContentRef.current) {
      detailsContentRef.current.scrollTop = 0;
    }
  }, [selectedSession]);

  if (!selectedRound) {
    return null;
  }

  const isSimulationRound = selectedRound.answerType === "simulation";
  console.log("JobApplicationinterviewRoundsDetails -> isSimulationRound", isSimulationRound, selectedRound);

  return (
    <div className="job-application-interview-rounds-details-container">
      <div className="job-application-interview-rounds-details-header">
        <Typography.Title level={5} style={{ margin: 0 }}>
          {selectedRound.title}
        </Typography.Title>
      </div>

      <div
        ref={detailsContentRef}
        className="job-application-interview-rounds-details-content"
      >
        {isSimulationRound ? (
          <SimulationReportPanel interviewSessionId={selectedSession._id} />
        ) : (
          <>
            <div className="job-application-interview-rounds-details-summary">
              <JobApplicationinterviewRoundsDetailsSummary
                session={selectedSession}
                roundConfig={roundConfig}
                handleViolationModal={handleViolationModal}
                handleScreenRecordingModal={handleScreenRecordingModal}
                passPercentage={passPercentage}
                isMustQualify={isMustQualify}
                attemptNumber={attemptNumber}
                isRestarted={isRestarted}
              />
            </div>

            <div className="job-application-interview-rounds-details-questions">
              <JobApplicationinterviewRoundsDetailsQuestions
                roundQuestions={roundQuestions}
                isRoundPending={
                  selectedSession?.status === "pending" ? true : false
                }
                questionFilter={questionFilter}
                setQuestionFilter={setQuestionFilter}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default JobApplicationinterviewRoundsDetails;
